import React from 'react';
import styled from 'styled-components/macro';
import Modal from '../../../components/Modal';
import { Button, ButtonGroup } from '../../../components/Buttons';
import { useTranslation } from 'react-i18next';
import { H2 } from '../../../components/Typography';
import { distances, colors, border } from '../../../styles/constants';
import { Json } from '../../../components/Formatters';
import Hr from '../../../components/Hr';
interface EventDetailsModalProps {
    details: any;
    closeModal: () => void;
}

const EventDetailsModal = (
    {
        details,
        closeModal,
    }: EventDetailsModalProps
) => {
    const { t } = useTranslation();
    return (
        <Modal onClose={closeModal}>
            <H2>{t('payments.transaction.event_details.title')}</H2>
            <Json data={details} />
            <Hr />
            <ButtonGroup>
                <Button type="button" onClick={closeModal}>
                    {t('payments.transaction.event_details.close')}
                </Button>
            </ButtonGroup>
        </Modal>
    );
};



export default EventDetailsModal;
